// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.



const deploymentEnvironment = "PROD";  //chnage only enviroment name ,When you are going to deploy
export const environment: any = getEnvironment(deploymentEnvironment);

function getEnvironment(deploymentEnvironment: string): any {
  if (deploymentEnvironment === "UAT") {
    return {
      production: false,
      apiUrl: '', //Changed
      appId: 'KD',
      imageBaseUrl: '', //Changed
      imageFolder: 'ResourceCenter/assets/itemCatalog/',
      imageUrl: '', //Changed
      maxCartQuoteItemCount: 99,
    };
  }
  else if (deploymentEnvironment === "DEV") {
    return {
      production: false,     
      apiUrl: 'https://psfapidev-avepgjgpftc6d8ez.canadacentral-01.azurewebsites.net/api',//Changed
      appId: 'KD',
      imageBaseUrl: 'https://psfapidev-avepgjgpftc6d8ez.canadacentral-01.azurewebsites.net', //veified //Changed 
      imageFolder: 'ResourceCenter/assets/itemCatalog/',         //veified
      imageUrl: 'https://psfapidev-avepgjgpftc6d8ez.canadacentral-01.azurewebsites.net', //Changed 
      maxCartQuoteItemCount: 99,
    };
  }
  else if (deploymentEnvironment === "QA") {
    return {
      production: false,
      //apiUrl: 'https://***/api',
      apiUrl: 'https://***/api', //Changed
      appId: 'KD',
      imageBaseUrl: 'https://***/api/', //Changed
      imageFolder: 'ResourceCenter/assets/itemCatalog/',
      imageUrl: 'https://***/api', //Changed
      maxCartQuoteItemCount: 99,
      rynohubapiUrl: 'https://***/api', //Changed
    };

  }
  else if (deploymentEnvironment === "PROD") {
    return {
      production: false,
      apiUrl: 'https://psfapiprod-fgdvg5fqabfkdja0.canadacentral-01.azurewebsites.net/api',
      appId: 'KD',
      imageBaseUrl: 'https://psfapiprod-fgdvg5fqabfkdja0.canadacentral-01.azurewebsites.net', //Changed 
      imageFolder: 'ResourceCenter/assets/itemCatalog/',
      imageUrl: 'https://psfapiprod-fgdvg5fqabfkdja0.canadacentral-01.azurewebsites.net', //Changed 
      maxCartQuoteItemCount: 99,
      rynohubapiUrl: 'https://reynohubapiprod-f8dhgqhuhfdtdadt.canadacentral-01.azurewebsites.net/api', //Changed 
    };
  }
  else if (deploymentEnvironment === "PWA_UAT") {
    return {
      production: true,
      apiUrl: 'https://***/aappsfapi/api', //Changed
      appId: 'KD',
      imageBaseUrl: 'https://***/aappsfapi/', //Changed
      imageFolder: 'ResourceCenter/assets/itemCatalog/',
      imageUrl: 'https://***/aappsfapi', //Changed
      maxCartQuoteItemCount: 99,
    };
  }
  else if (deploymentEnvironment === "PWA_INTERNAL_UAT") {
    return {
      production: false,
      //apiUrl: 'https:////Changed/api',
      apiUrl: 'https://***/api',  //Changed
      appId: 'KD',
      imageBaseUrl: 'https://***/', //veified //Changed 
      imageFolder: 'assets/itemCatalog/',         //veified
      imageUrl: 'https://***', //Changed 
      maxCartQuoteItemCount: 99,
    };
  }
  else { //local
    return {
      production: false,
      apiUrl: 'https://localhost:44356/api', //Changed
      //apiUrl: 'http://***/api', //Changed
      appId: 'KD',
      imageBaseUrl: 'https://localhost:44356', //Changed
      imageFolder: 'ResourceCenter/assets/itemCatalog/',
      imageUrl: 'https://localhost:44356',//Changed
      maxCartQuoteItemCount: 99,
      rynohubapiUrl: 'https://localhost:7254/api', //Changed
    };
  }

}


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
